export default "__VITE_ASSET__Bpq0Qi$r__"